import { render, staticRenderFns } from "./AppLanguageCurrencyModal.vue?vue&type=template&id=e68715f4"
import script from "./AppLanguageCurrencyModal.vue?vue&type=script&lang=js"
export * from "./AppLanguageCurrencyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppModal: require('/home/forge/ab.farescraper.com/components/AppModal.vue').default})
